import React, { useState } from "react";

//components material mui
import {
    Button,
    DialogContent,
    DialogActions,
    Typography,
    Box,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

//components
import { DialogoBoostrap } from "../../ControlUsuario/DialogoPersonalizado/DialogoBoostrap";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

let funcionAbrirModal;
let validaAbrirModal;

/**
 * Modal de aviso cuando ya existe un pago en proceso (validaPagoEnProcesolinea === true).
 * No envia al pago; el usuario debe cerrar otros procesos de pago antes de reintentar.
 */
export const DialogoPagoPendiente = () => {
    const { etiquetas } = useGlobalState();

    const [abierto, setAbierto] = useState(false);
    funcionAbrirModal = setAbierto;
    validaAbrirModal = abierto;

    const lbl = etiquetas?.PagoEnLinea || {};

    return (
        <DialogoBoostrap
            open={abierto}
            onClose={() => setAbierto(false)}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent style={{ textAlign: "center", padding: "24px" }}>
                <Box
                    style={{
                        display: "inline-flex",
                        padding: 12,
                        borderRadius: 12,
                        backgroundColor: "#FFF4E5",
                        marginBottom: 12,
                    }}
                >
                    <InfoOutlinedIcon style={{ color: "#B26A00", fontSize: 28 }} />
                </Box>
                <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, color: "#082375" }}>
                    {lbl.Et_TituloPagoPendiente || "Pago en proceso"}
                </Typography>
                <Typography style={{ fontSize: 14, color: "#3F425D" }}>
                    {lbl.Et_DescripcionPagoPendiente ||
                        "Ya tienes un pago en proceso. Cierra los otros procesos de pago abiertos en tu navegador antes de continuar."}
                </Typography>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center", padding: "8px 24px 20px" }}>
                <Button
                    variant="contained"
                    style={{ backgroundColor: "#082375", color: "#FFFFFF" }}
                    onClick={() => setAbierto(false)}
                >
                    {etiquetas?.General?.Et_tbnAceptar || "Aceptar"}
                </Button>
            </DialogActions>
        </DialogoBoostrap>
    );
};

export const mostrarDialogoPagoPendiente = () => {
    funcionAbrirModal(!validaAbrirModal);
};
